export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/UYODesktopPoster-a23c9e7c10609c96bb123b4f14f4b1a3.jpg";